import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import { weightPresets } from './model';
import css from './style.module.css';

export const Layout = forwardRef<HTMLElement, Props>(function Component(
  {
    Component = 'span',
    baseClassName,
    weight,
    normalize = false,
    inline = false,
    caps = false,
    center = false,
    children,
    ...props
  },
  forwardedRef
) {
  return (
    <RootComponent
      {...props}
      Component={Component}
      baseClassName={clsx(baseClassName, css.root, weightPresets[weight], {
        [css.normalize]: normalize,
        [css.inline]: inline,
        [css.caps]: caps,
        [css.center]: center,
      })}
      ref={forwardedRef}
    >
      {children}
    </RootComponent>
  );
});
